// extracted by mini-css-extract-plugin
export var statItem = "_jl-1";
export var statsRow = "_jl-0";